import config from '../utils/config'
import request from '../utils/request'

const {api} = config
const {invitationTpl, invitationTpls} = api



/**
 * 查找邀请函模板
 */
export async function findInvitationTpl(params) {
    return request({url: invitationTpl, method: 'get', data: params,})
}

/**
 * 创建邀请函模板
 */
export async function createInvitationTpl(params) {
    return request({url: invitationTpls, method: 'post', data: params,})
}

/**
 * 更新邀请函模板
 */
export async function updateInvitationTpl(params) {
    return request({url: invitationTpl, method: 'put', data: params,})
}

/**
 * 删除邀请函模板
 */
export async function deleteInvitationTpl(params) {
    return request({url: invitationTpl, method: 'delete', data: params,})
}


/**
 * 查找邀请函模板列表
 */
export async function findInvitationTpls(params) {
    return request({url: invitationTpls, method: 'get', data: params,})
}

/**
 * 删除邀请函模板
 */
export async function deleteInvitationTpls(params) {
    return request({url: invitationTpls, method: 'delete', data: params,})
}



// WEBPACK FOOTER //
// ./src/services/invitationTpl.js